import type { LivestreamPanelMode } from "./types";

type ResolveLivestreamStockfishAvailabilityInput = {
  visiblePlyCount: number;
  displayPly: number;
  reviewPly: number | null;
  mode: LivestreamPanelMode;
};

export type LivestreamStockfishAvailability = {
  allowed: boolean;
  reason: "available" | "current_live_position" | "no_moves" | "submitting";
};

export function resolveLivestreamStockfishAvailability({
  visiblePlyCount,
  displayPly,
  reviewPly,
  mode,
}: ResolveLivestreamStockfishAvailabilityInput): LivestreamStockfishAvailability {
  if (mode === "submitting") {
    return { allowed: false, reason: "submitting" };
  }

  if (visiblePlyCount <= 0) {
    return { allowed: false, reason: "no_moves" };
  }

  const isCurrentPosition = reviewPly === null || displayPly >= visiblePlyCount;
  if (isCurrentPosition) {
    return { allowed: false, reason: "current_live_position" };
  }

  return { allowed: true, reason: "available" };
}
